import { createElement, Fragment } from 'react';
import cn from 'classnames';
import { useTranslate } from '@awardit/react-use-translate';
import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { useLocation, Link } from 'react-router-dom';
import { Pagination } from '../Pagination/index.js';
import { ProductList } from '../ProductList/index.js';
import { parseParams, stringifyParams } from '../../helpers/location-search-string.js';
import styles from 'ui-components/PaginatedProductList.scss';

var _excluded = ["updating", "numPages", "productList", "className", "uiContext", "children", "ProductCardComponent", "breadcrumbLinks", "category", "productsPerRow", "title", "pointsPriceId"];
var PaginatedProductList = function PaginatedProductList(_ref) {
  var updating = _ref.updating,
    numPages = _ref.numPages,
    productList = _ref.productList,
    className = _ref.className,
    uiContext = _ref.uiContext,
    children = _ref.children,
    ProductCardComponent = _ref.ProductCardComponent,
    breadcrumbLinks = _ref.breadcrumbLinks,
    category = _ref.category,
    productsPerRow = _ref.productsPerRow,
    title = _ref.title,
    pointsPriceId = _ref.pointsPriceId,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  var t = useTranslate();
  var location = useLocation();
  var params = parseParams(location.search);
  var page = typeof params.page === "string" ? Number.parseInt(params.page, 10) : 1;
  var _uiContext = uiContext(),
    isDesktop = _uiContext.isDesktop;
  if (updating) {
    return /*#__PURE__*/createElement("div", {
      className: className
    }, /*#__PURE__*/createElement(ProductList, {
      products: [null, null, null, null, null, null, null, null]
    }));
  }
  var PaginationButton = function PaginationButton(_ref2) {
    var _cn;
    var active = _ref2.active,
      children = _ref2.children,
      page = _ref2.page;
    var newSearch = _extends({}, params, {
      page: String(page)
    });
    return /*#__PURE__*/createElement(Link, {
      disabled: active,
      className: cn(styles.paginationButton, (_cn = {}, _cn[styles.active] = active, _cn)),
      to: stringifyParams(newSearch)
    }, children);
  };
  return /*#__PURE__*/createElement("div", {
    className: styles.block
  }, productList.items.length > 0 ? /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement(ProductList, _extends({}, rest, {
    products: productList.items,
    heading: title,
    category: category,
    breadcrumbLinks: breadcrumbLinks,
    ProductCardComponent: ProductCardComponent,
    productsPerRow: productsPerRow,
    loading: updating,
    pointsPriceId: pointsPriceId
  })), children, numPages > 1 && /*#__PURE__*/createElement("div", {
    className: styles.paginationWrapper
  }, /*#__PURE__*/createElement(Pagination, {
    className: styles.pagination,
    currentPage: page,
    pageCount: numPages,
    ButtonComponent: PaginationButton,
    maxButtonCount: isDesktop ? 10 : 5
  }))) : /*#__PURE__*/createElement("p", {
    className: styles.empty
  }, t("PRODUCTLIST.EMPTY")));
};

export { PaginatedProductList };
//# sourceMappingURL=index.js.map
